import { Navigate, Outlet } from "react-router-dom";
import { useAuthStatus } from "../hooks/useAuthState";
import Loader from "./Loader";

const PrivateRoute = () => {
  const { loggedIn, checkingStatus } = useAuthStatus();

  if (checkingStatus) {
    return (
      <div className="page-loader-center" aria-busy="true">
        <Loader size="50" />
      </div>
    );
  }

  return loggedIn ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
